export class CONFIG {
    Type: string = "CONFIG";
    SerialNumber: string;
    Config: string;
}